import { render, staticRenderFns } from "./GameColor.vue?vue&type=template&id=f1b99cf4&"
import script from "./GameColor.vue?vue&type=script&lang=js&"
export * from "./GameColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports